import { render, staticRenderFns } from "./key-features.vue?vue&type=template&id=450c22c8&scoped=true&"
import script from "./key-features.vue?vue&type=script&lang=js&"
export * from "./key-features.vue?vue&type=script&lang=js&"
import style0 from "./key-features.vue?vue&type=style&index=0&id=450c22c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450c22c8",
  null
  
)

export default component.exports